<template>
  <div>
    <register-header></register-header>
    <div class="main-container-wrapper heiCen" :style="defaultHeight">
      <el-card class="cardd" shadow="never">
        <div class="register">
          <span :class="{ active: action }">个人注册</span>
          |
          <span @click="farenzhuce">法人注册</span>
        </div>
        <div style="margin: 30px 0">
          <el-steps
            space="100%"
            :active="numActi"
            finish-status="success"
            align-center
          >
            <el-step title="个人信息"></el-step>
            <el-step title="账号信息"></el-step>
            <el-step title="注册完成"></el-step>
          </el-steps>
        </div>
        <div class="formSty" v-show="oneJD">
          <el-form
            :rules="rules1"
            label-position="right"
            ref="applyForm1"
            :model="applyForm"
            label-width="100px"
          >
            <el-form-item label="个人姓名" prop="name">
              <el-input v-model="applyForm.name"></el-input>
            </el-form-item>
            <el-form-item label="证件号码" prop="certificateNum">
              <el-select
                clearable
                v-model="applyForm.certificateTypeCode"
                style="width: 30%"
                @change="certificateTypeCodeChange()"
              >
                <el-option
                  v-for="item in applyForm.certificateTypeNameList"
                  :key="item.dataCode"
                  :label="item.dataName"
                  :value="item.dataCode"
                ></el-option>
              </el-select>
              <el-input
                v-model="applyForm.certificateNum"
                @change="IDVerification()"
                style="width: 65%; margin-left: 5%"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="证件有效期"
              prop="termStart"
              v-show="applyForm.certificateTypeCode == '0'"
            >
              <el-col :span="9">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  popper-class="timeclass"
                  v-model="applyForm.termStart"
                  style="width: 100%"
                  :picker-options="startOption"
                ></el-date-picker>
              </el-col>
              <el-col style="margin-left: 0.5%" class="line" :span="2"
                >至</el-col
              >
              <el-col :span="9">
                <el-date-picker
                  :disabled="termEndDis"
                  type="date"
                  placeholder="选择日期"
                  v-model="applyForm.termEnd"
                  popper-class="timeclass"
                  style="width: 100%"
                  :picker-options="endOption"
                ></el-date-picker>
              </el-col>
              <el-col style="margin-left: 4%" :span="2">
                <el-checkbox
                  v-model="applyForm.isLongTerm"
                  @change="isLongTermChange()"
                  >永久</el-checkbox
                >
              </el-col>
            </el-form-item>
            <el-form-item label="所在地区">
              <el-select
                clearable
                v-model="applyForm.districtCode"
                style="width: 33%; margin-right: 0.5%"
                placeholder="省"
                @change="districtCodeChange()"
              >
                <el-option
                  v-for="item in applyForm.districtCodeList"
                  :key="item.dataCode"
                  :label="item.dataName"
                  :value="item.dicId"
                ></el-option>
                <!-- :value="`${item.dataCode}|${item.dicId}`" -->
              </el-select>
              <el-select
                clearable
                v-model="applyForm.pendingDisposalNum"
                style="width: 33%; margin-right: 0.5%"
                placeholder="市"
                @change="pendingDisposalNumChange()"
              >
                <el-option
                  v-for="item in applyForm.pendingDisposalNumList"
                  :key="item.dataCode"
                  :label="item.dataName"
                  :value="item.dicId"
                ></el-option>
              </el-select>
              <el-select
                clearable
                v-model="applyForm.processedNum"
                style="width: 33%"
                placeholder="县"
              >
                <el-option
                  v-for="item in applyForm.processedNumList"
                  :key="item.dataCode"
                  :label="item.dataName"
                  :value="item.dicId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="通信地址" prop="address">
              <el-input v-model="applyForm.address"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="telNo">
              <el-input
                placeholder="请输入内容"
                v-model="applyForm.telNo"
                style="width: 60%; vertical-align: middle"
                @change="numVerification()"
              >
                <el-button
                  slot="append"
                  class="verification"
                  type="primary"
                  ref="append"
                  @click="verCode"
                  >{{ inner }}</el-button
                >
              </el-input>
              <el-input
                placeholder="输入验证码"
                v-model="verificationCode"
                style="width: 35%; margin-left: 5%"
              ></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email">
              <el-input v-model="applyForm.email"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="formSty" v-show="twoJD">
          <el-form
            label-position="right"
            :rules="rules2"
            ref="applyForm2"
            :model="applyForm"
            label-width="100px"
          >
            <el-form-item label="用户账号" prop="userName">
              <el-input
                v-model="applyForm.userName"
                @blur="userNameChange()"
              ></el-input>
            </el-form-item>
            <el-form-item label="账号密码" prop="cypher">
              <el-input
                v-model="applyForm.cypher"
                show-password
                placeholder="6~16位字符，至少包含三种元素：数字、大写字母、小写字母或特殊字符"
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="isPassword">
              <el-input
                show-password
                v-model="applyForm.isPassword"
                @change="isPasswordChange()"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="formSty" v-show="threeJD">
          <div style="font-size: 30px; color: #67c23a; font-weight: 700">
            注册成功
          </div>
          <p style="font-size: 20px">
            恭喜您,<span style="color: #2264a0">{{ applyForm.userName }}</span>
            已注册成功
          </p>
          <p style="font-size: 16px">请根据提示操作</p>
          <el-button v-show="goJD" @click="goBack">返回首页</el-button>
          <el-button style="margin-left: 15px" v-show="goJD" @click="personal"
            >返回个人登录</el-button
          >
        </div>
      </el-card>
    </div>
    <div class="foot">
      <el-divider></el-divider>
      <el-checkbox v-model="checked" v-show="preJD"
        >我已阅读并同意
        <span @click="spanDis = true">{{ span }}</span></el-checkbox
      ><br />
      <el-button @click="pre()" v-show="preJD" style="margin-top: 20px"
        >上一步</el-button
      >
      <el-button @click="next('applyForm1')" v-show="nextJD">下一步</el-button>
      <el-button
        @click="regi('applyForm2')"
        v-show="preJD"
        style="margin-left: 15px"
        >注册</el-button
      >
    </div>
    <register-footer></register-footer>
    <el-dialog title="提示" :visible.sync="phoneDis" width="30%">
      <span> 请输入手机号码 </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="phoneDis = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="注册协议和隐私条款"
      :visible.sync="spanDis"
      width="50%"
      center
    >
      <bps-bps></bps-bps>
    </el-dialog>
  </div>
</template>

<script>
import registerHeader from "../../components/registerHeader.vue";
import registerFooter from "../../components/registerFooter.vue";
import {
  individualRegistration1,
  individualRegistration2,
} from "../../utils/formValidation";
import { Message } from "element-ui";
import md5 from "js-md5";
import util from "../../utils/util";
import bpsBps from "../bps/bpsBps.vue";
import { url } from "../../utils/axiosUrl";
export default {
  name: "IndividualRegistration",
  data() {
    return {
      url: url,
      defaultHeight: {
        height: "",
      },
      startOption: {
        // 指定开始限制时间
        disabledDate: (date) => {
          // let data = this.applyForm.termEnd != '' ? Date.now() : this.applyForm.termEnd
          // return date >= data
          return date >= Date.now()
        }
      },
      endOption: {
        // 指定终止日期
        disabledDate: (date) => {
          // let data = this.applyForm.termStart == '' ? '' : this.applyForm.termStart
          // return date <= Date.now() || date < data
          return date <= Date.now()
        }
      },
      show: false,
      // 表单验证
      rules1: individualRegistration1,
      rules2: individualRegistration2,
      span: "《注册协议和隐私条款》",
      // 判断手机验证码无号码弹窗
      phoneDis: false,
      // 判断注册协议显示
      spanDis: false,
      //   判断个人注册
      action: true,
      //   判断步骤
      numActi: 0,
      // 到达二阶段控制一阶段
      oneJD: true,
      twoJD: false,
      threeJD: false,
      nextJD: true,
      preJD: false,
      goJD: false,
      applyForm: {
        // 第一阶段===================================================
        // 个人姓名
        name: null,
        // 证件类型编码
        certificateTypeCode: "0",
        // 证件类型名称
        certificateTypeName: null,
        certificateTypeNameList: [],
        // 证件号
        certificateNum: null,
        // 有效启始
        termStart: null,
        // 有效结束
        termEnd: null,
        // 是否永久
        isLongTerm: false,
        // 通信地址
        address: null,
        // 手机号
        telNo: null,
        // 电子邮箱
        email: null,
        // 省
        districtCode: null,
        districtCodeList: [],
        // 市
        pendingDisposalNum: null,
        pendingDisposalNumList: [],
        // 县
        processedNum: null,
        processedNumList: [],
        // 第二阶段======================================================
        // 用户名
        userName: null,
        // 明文密码
        cypher: null,
        // md5密码
        password: null,
        //base64密码
        basePassword: null,
        // 确认密码
        isPassword: null,
        // 个人注册标识
        userType: "personal",
      },
      checked: true,
      // 省model
      province: false,
      // 市model
      cityModel: false,
      // 县model
      areaModel: false,
      // 验证码文字
      inner: "发送验证码",
      // 验证码内容
      verificationCode: null,
      // 控制结束日期的disabled
      termEndDis: false,
      id1: false,
      id2: false,
    };
  },
  components: {
    registerHeader,
    registerFooter,
    bpsBps,
  },

  mounted() {
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    this.getProvinceList("");
    this.getIdentityList();
  },
  methods: {
    // 改变身份证明清空身份证号
    certificateTypeCodeChange() {
      this.applyForm.certificateNum = null;
    },
    // 获取省份
    getProvinceList(val) {
      let Url = util.getAjaxUrl("axiosOne");
      this.$http.get(Url + "/framework/province").then((res) => {
        if (res.status === 200) {
          if (this.province === true) {
            let list = res.data.filter((item) => item.dataCode === val);
            if (list.length !== 0) {
              this.applyForm.districtCode = list[0].dicId;
            }
            // 370123199902175219
            let pro2 = this.applyForm.certificateNum.slice(0, 4).padEnd(6, "0");
            this.cityModel = true;
            this.getCityList(this.applyForm.districtCode, pro2);
            this.province = false;
          } else {
            this.applyForm.districtCodeList = res.data;
          }
        }
      });
    },
    // 省份改变改变市
    districtCodeChange() {
      if (this.applyForm.districtCode) {
        this.getCityList(this.applyForm.districtCode, "");
        // this.applyForm.districtCode=null;
        this.applyForm.pendingDisposalNum = null;
        this.applyForm.pendingDisposalNumList = [];
        this.applyForm.processedNum = null;
        this.applyForm.processedNumList = [];
      }
    },
    // 获取市
    getCityList(val, echo) {
      let Url = util.getAjaxUrl("axiosOne");
      let params = {
        parentId: val,
      };
      this.$http.post(Url + "/framework/find", params).then((res) => {
        if (res.status === 200) {
          if (this.cityModel === true) {
            let list = res.data.filter((item) => item.dataCode === echo);
            if (list.length !== 0) {
              this.applyForm.pendingDisposalNum = list[0].dicId;
            }
            let pro3 = this.applyForm.certificateNum.slice(0, 6).padEnd(6, "0");
            this.areaModel = true;
            this.getAreaList(this.applyForm.pendingDisposalNum, pro3);
            this.cityModel = false;
          }
          this.applyForm.pendingDisposalNumList = res.data;
        }
      });
    },
    // 市改变改变区/县
    pendingDisposalNumChange() {
      if (this.applyForm.pendingDisposalNum) {
        this.getAreaList(this.applyForm.pendingDisposalNum, "");
        // this.applyForm.pendingDisposalNum=null;
        this.applyForm.processedNum = null;
        this.applyForm.processedNumList = [];
      }
    },
    // 获取区
    getAreaList(val, echo) {
      let Url = util.getAjaxUrl("axiosOne");
      let params = {
        parentId: val,
      };
      this.$http.post(Url + "/framework/find", params).then((res) => {
        if (res.status === 200) {
          if (this.areaModel === true) {
            let list = res.data.filter((item) => item.dataCode === echo);
            if (list.length !== 0) {
              this.applyForm.processedNum = list[0].dicId;
            }
            this.areaModel = false;
          }
          this.applyForm.processedNumList = res.data;
        }
      });
    },
    // 获取身份证件列表
    getIdentityList() {
      let Url = util.getAjaxUrl("axiosOne");
      this.$http.get(Url + "/framework/findIdType").then((res) => {
        if (res.status === 200) {
          this.applyForm.certificateTypeNameList = res.data;
        }
      });
    },
    // 整体自适应
    getHeight() {
      this.defaultHeight.height = window.innerHeight - 330 + "px";
    },
    // 点击永久隐藏结束日期
    isLongTermChange() {
      if (this.applyForm.isLongTerm === true) {
        this.applyForm.termEnd = null;
        this.termEndDis = true;
      } else {
        this.termEndDis = false;
      }
    },
    // 手机验证码
    verCode() {
      this.numVerification();
      if (this.applyForm.telNo == null) {
        this.phoneDis = true;
      } else {
        if (!/^1[34578]\d{9}$/.test(this.applyForm.telNo)) {
          Message.error("请填写正确的手机号！");
        } else {
          if (this.show) {
            return false;
          }
          let Url = util.getAjaxUrl("axiosOne");
          this.$http
            .get(
              Url +
                "/api/user/createVliteCode?phone=" +
                this.applyForm.telNo +
                "&type=4",
              {
                headers: {
                  // 'Origin': 'http://172.20.233.129:9100',
                  "Access-Control-Allow-Origin": "*",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 200) {
                let that = this,
                  time = 60;
                var sendTimer = setInterval(function () {
                  that.show = true;
                  time--;
                  that.inner = time + "s后重新发送";
                  if (time < 0) {
                    that.show = false;
                    that.verificationCode = null;
                    clearInterval(sendTimer);
                    that.inner = "获取验证码";
                  }
                }, 1000);
              }
            });
        }
      }
    },
    //跳转法人注册
    farenzhuce() {
      this.$router.push("/RegisterLPStep");
    },
    // 点击下一步
    next(formName) {
      let startTime = this.applyForm.termStart;
      let endTime = this.applyForm.termEnd;
      // if (startTime && endTime) {
      //   if (startTime.getTime() > endTime.getTime()) {
      //     this.$message.error("开始日期不能大于结束日期");
      //     return;
      //   }
      // } else {
      //   this.$message.error("请选择日期");
      //   return; 
      // }
      if(!startTime){
        this.$message.error("请选择日期");
        return ;
      }
      if(!endTime && !this.applyForm.isLongTerm){
        this.$message.error("请选择日期1");
        return ;
      }
      this.numActi++;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.id1 === true) {
            if (this.numActi == 1) {
              let Url = util.getAjaxUrl("axiosOne");
              this.$http
                .get(
                  Url +
                    `/framework/validateCode?phone=${this.applyForm.telNo}&vCode=${this.verificationCode}`
                )
                .then((res) => {
                  if (res.status === 200) {
                    if (res.data.code === 200) {
                      if (res.data.data === false) {
                        Message.error(res.data.msg);
                        this.numActi--;
                      } else {
                        this.oneJD = false;
                        this.twoJD = true;
                        this.threeJD = false;
                        this.goJD = false;
                        this.nextJD = false;
                        this.preJD = true;
                      }
                    } else {
                      Message.error(res.data.msg);
                      this.numActi--;
                    }
                  }
                });
            } else {
              Message.warning("有未填写内容");
              this.numActi--;
            }
          } else {
            Message.error("证件号码格式错误");
            this.numActi--;
          }
        } else {
          this.$nextTick(() => {
            let isError = document.getElementsByClassName("is-error");
            isError[0].scrollIntoView({
              // 滚动到指定节点
              // 值有start,center,end，nearest，当前显示在视图区域中间
              block: "center",
              // 值有auto、instant,smooth，缓动动画（当前是慢速的）
              behavior: "smooth",
            });
          });
          Message.warning("有未填写内容");
          this.numActi--;
        }
      });
    },
    // 点击注册
    regi(formName) {
      let Base64 = require("js-base64").Base64;
      this.numActi++;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.id2 === true) {
            if (this.numActi == 2 && this.checked == true) {
              let Url = util.getAjaxUrl("axiosOne");
              this.applyForm.password = md5(this.applyForm.cypher);
              this.applyForm.basePassword = Base64.encode(
                this.applyForm.cypher
              );
              // this.applyForm.password = md5(this.applyForm.cypher);
              this.$http
                .post(Url + "/framework/register", this.applyForm)
                .then((res) => {
                  console.log(res);
                  if (res.status === 200) {
                    if (res.data.code === 200) {
                      this.oneJD = false;
                      this.twoJD = false;
                      this.threeJD = true;
                      this.nextJD = false;
                      this.goJD = true;
                      this.preJD = false;
                      Message.success(res.data.msg);
                    } else {
                      Message.error(res.data.msg);
                      this.numActi--;
                    }
                  }
                });
            } else {
              Message.warning("请选择注意协议和隐私条款");
              this.numActi--;
            }
          } else {
            Message.warning("两次输入密码不一致");
            this.numActi--;
          }
        } else {
          this.$nextTick(() => {
            let isError = document.getElementsByClassName("is-error");
            isError[0].scrollIntoView({
              // 滚动到指定节点
              // 值有start,center,end，nearest，当前显示在视图区域中间
              block: "center",
              // 值有auto、instant,smooth，缓动动画（当前是慢速的）
              behavior: "smooth",
            });
          });
          Message.warning("有未填写内容");
          this.numActi--;
        }
      });
    },
    // 点击上一个
    pre() {
      if (this.numActi == 1) {
        this.numActi--;
        this.oneJD = true;
        this.twoJD = false;
        this.threeJD = false;
        this.goJD = false;
        this.nextJD = true;
        this.preJD = false;
      }
    },
    // 手机号格式验证
    numVerification() {
      if (this.applyForm.telNo) {
        this.getIsTelNoList(this.applyForm.telNo);
      }
    },
    // 判断手机号是否注册过
    getIsTelNoList(val) {
      let Url = util.getAjaxUrl("axiosOne");
      let params = {
        telNo: val,
        userType: "person",
      };
      this.$http.post(Url + "/framework/compareTelNo", params).then((res) => {
        if (res.status === 200) {
          if (res.data === false) {
            this.show = true;
            if (val !== "1") {
              Message.error("该手机号已被注册！");
            }
          } else {
            this.show = false;
          }
        }
      });
    },
    // 身份证格式验证并且和省市县关联、
    IDVerification() {
      if (this.applyForm.certificateTypeCode == "0") {
        let reg = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (reg.test(this.applyForm.certificateNum) == true) {
          let pro1 = this.applyForm.certificateNum.slice(0, 2).padEnd(6, "0");
          this.province = true;
          this.id1 = true;
          this.getProvinceList(pro1);
        } else {
          Message.error("证件号码格式错误");
          this.id1 = false;
        }
      }
    },
    // 验证确认密码和密码的相同
    isPasswordChange() {
      if (this.applyForm.isPassword === null) {
        Message.error("请再次输入密码");
        this.id2 = false;
      } else if (this.applyForm.isPassword !== this.applyForm.cypher) {
        Message.error("两次输入密码不一致");
        this.id2 = false;
      } else {
        this.id2 = true;
      }
    },
    // 判断账号是否已存在
    userNameChange() {
      if (this.applyForm.userName !== null) {
        let Url = util.getAjaxUrl("axiosOne");
        this.$http
          .get(Url + `/framework/judge/${this.applyForm.userName}`)
          .then((res) => {
            if (res.status === 200) {
              if (res.data.code === 200) {
                if (res.data.data === false) {
                  Message.error("该账号已被注册");
                }
              }
            }
          });
      }
    },
    // 返回首页
    goBack() {
      this.$router.push("/home");
    },
    // 返回个人登录
    personal() {
      // this.$router.push("/home");
      window.location.href = url + ":8088/#/login?type=2";
    },
  },
};
</script>

<style scoped lang="less">
@import "../../styles/theme";
/deep/.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #2264a0;
}
.formSty {
  height: 100%;
  width: 60%;
  margin: 0 auto;
}
.formSty1 {
  height: 100%;
  width: 60%;
  margin: 20px 10px 20px;
}

/deep/.el-button:focus,
/deep/.el-button:hover {
  color: #2264a0;
  border-color: #bdd1e3;
  background-color: #e9f0f6;
}

/deep/.el-input__inner {
  height: 32px;
  border-color: black;
  // line-height: 32px;
}
/deep/.el-input__inner:hover {
  border-color: black;
}
/deep/.el-input__inner:focus {
  border-color: #2264a0;
}
/deep/.el-select .el-input.is-focus {
  border-color: #2264a0;
}
/deep/.el-select .el-input.is-focus .el-input__inner {
  border-color: #2264a0;
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #2264a0;
}
/deep/.el-checkbox__inner:hover {
  border-color: #2264a0;
}
/deep/.el-checkbox__inner:focus {
  border-color: #2264a0;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #2264a0;
  background-color: #2264a0;
}
.active {
  color: @theme-color;
  z-index: 10;
  border-bottom: 3px solid @theme-color;
}
.register {
  width: 100%;
  margin-top: 20px;
  height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 2px solid #c0c4cc;
  cursor: pointer;
  span {
    text-align: center;
    line-height: 40px;
    display: inline-block;
    height: 40px;
    width: 50%;
    font-size: 14px;
  }
}
.heiCen {
  text-align: center;
  min-height: 600px;
}
.smaCen {
  height: 100%;
  background: #fff;
}
.el-input-group__append {
  padding: 0;
}
.cardd {
  border: none;
}
.foot {
  text-align: center;
}
/deep/.el-button--primary {
  background: #2264a0 !important;
  color: #fff !important;
  border-color: #2264a0 !important;
  padding: 0 10px;
  height: 32px;
  line-height: 32px;
  display: inline-block;
}
.el-select-dropdown__item.selected {
  color: #2264a0 !important;
}
</style>
